var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header__wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row header"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{attrs:{"src":`./svg/logo_${_vm.mode}.svg`}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }